import { SelectItem } from "primeng/api";
import { FilterOperator } from "../../models/models.swagger.generated";

export class FilterMap {
    static getFilterOperator(operator: string): FilterOperator {
        switch (operator) {
            case 'startsWith':
                return FilterOperator.StartsWith;
            case 'contains':
                return FilterOperator.Contains;
            case 'endsWith':
                return FilterOperator.EndsWith;
            case 'equals':
                return FilterOperator.Equal;
            case 'notEquals':
                return FilterOperator.NotEqual;
            default:
                return FilterOperator.Contains;
        }
    }

    static getStringFilterMatchModeOptions(): SelectItem[] {
        return [
            { label: 'Contains', value: 'contains' },
            { label: 'Starts With', value: 'startsWith' },
            { label: 'Ends With', value: 'endsWith' },
            { label: 'Equals', value: 'equals' },
            { label: 'Not Equals', value: 'notEquals' }
        ]
    }
}